import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class TwilioNumberSelectionModalStore {
  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  open = () => {
    this._entities.numbersStore.initSelectNumberModal()
  }
}
